import React from "react"
import './WinnersBlock.scss'
import { Container } from "react-bootstrap";

function WinnersBlock() {

    return (
        <div className={`winners-block`}>
            <div className="blue-rect">
                <Container>
                    <div className="blue-rect-container">
                        <div className="photo">
                            <div className="num-circle-container">
                                <div className="num-circle">
                                    <div className="num pr6">4</div>
                                    <div className="txt">дня</div>
                                </div>
                                <div className="num-circle">
                                    <div className="num">25</div>
                                    <div className="txt">человек</div>
                                </div>
                            </div>
                        </div>
                        <div className="text">
                            <h3>Победителям</h3>
                            <p>
                                {`Бесплатная поездка \nв Москву для 25 человек \nс культурно-экскурсионной \nпрограммой`}
                            </p>
                        </div>
                        <div className="photo2"></div>
                    </div>
                </Container>
            </div>
            <Container className="down-corner-container">
                <div className="down-corner">
                    <div className="diploms">
                        <div className="diplom-img"></div>
                        <div className="diplom-text">
                            {`Дипломы \nпобедителям`}
                        </div>
                    </div>
                    <div className="round-image-block">
                        <div className="blouse"></div>
                        <div className="cup"></div>
                        <div className="text">Подарки</div>
                    </div>
                </div>
            </Container>
        </div >
    );
}

export default WinnersBlock;